import React, {useEffect, useState} from "react";
import {toast, ToastContainer} from "react-toastify";
import {Snackbar, Typography} from "@material-ui/core";
import {Alert} from "@material-ui/lab";

export default function OrdersPendingComponent({ordersPendingMsg}) {
    let details = ordersPendingMsg.details;
    let count = ordersPendingMsg.count;
    let content = null;
    if (details !== undefined) {
        content = (<>
            order actions pending: {count}
            {details.map((detail, index) => {
                return (<>
                    <p>
                        <b>{index + 1}) {detail["type"]}</b>
                        <p>
                            {Object.keys(detail["objectNode"]).map(info => {
                                return <>{info}-{detail["objectNode"][info]} </>
                            })} time: {new Date(detail["timeOfOrder"]).getHours() + ":" + new Date(detail["timeOfOrder"]).getMinutes() + ":" + new Date(detail["timeOfOrder"]).getSeconds()}
                        </p>
                    </p>
                </>)
            })}
        </>)
        ;
    }
    let component = <Typography style={{fontSize: 13}}>{content}</Typography>;
    return <Snackbar open={count > 0} anchorOrigin={{horizontal: "right", vertical: "top"}}>
        <Alert severity={"warning"}>{component}</Alert>
    </Snackbar>
}

function OrdeadsfrsPendingComponent({ordersPendingMsg}) {
    console.log(JSON.stringify(ordersPendingMsg));
    let count = ordersPendingMsg.count;
    if (count === undefined || count === 0) {
        return null;
    }

//html:
    let details = ordersPendingMsg.details;
    let content = (<>
        order actions pending: {count}
        {details.map((detail, index) => {
            return (<>
                <p>
                    {index + 1}) type-{detail["type"]}:
                    <p>
                        {Object.keys(detail["objectNode"]).map(info => {
                            return <>{info}-{detail["objectNode"][info]} </>
                        })} time: {new Date(detail["timeOfOrder"]).getHours() + ":" + new Date(detail["timeOfOrder"]).getMinutes() + ":" + new Date(detail["timeOfOrder"]).getSeconds()}
                    </p>
                </p>
            </>)
        })}
    </>);
    /*let details = ordersPendingMsg.details;
    for (let i in details) {
    let detail = details[i];
    let type = <><br/>type - {detail["type"]}.</>;
    content += type;
    /!*let detailString = "";
    let params = detail["objectNode"];
    for (let info in params) {
    //console.log(info);
    //console.log(params[info])
    detailString += <>{info}-{params[info]}. </>;
}
    let orderInfo = type + detailString;
    content += orderInfo;*!/
}*/
    /*let content = "order actions pending: " + count;
    let details = ordersPendingMsg.details;
    for (let i in details) {
    let detail = details[i];
    let type = "\n" + "type-" + detail["type"] + ". ";
    let detailString = "";
    let params = detail["objectNode"];
    for (let info in params) {
    detailString += info + "-" + params[info] + ". ";
}
    let orderInfo = type + detailString;
    content += orderInfo;
}*/
    toast["warning"](<Typography style={{fontSize: 13}}>{content}</Typography>, {
            position: "top-right",
            draggable: true,
            //type: notificationMsg["severityScore"]

        }//, {
        //autoDismissTimeout: 500,
        //appearance: notificationMsg["severityScore"],
        //autoDismiss: true,
        //placement: 'bottom-left'
        //})
    )
    ;
    return <><ToastContainer newestOnTop limit={1} autoClose={false} hideProgressBar/></>;
}